import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import { setTranslations, setWebMode, setPeepsScors, setDate, setEasySearch,setSortTypes, setAboutPage, setFaq,
    setFlowInformation, setEasyBuy, setFooterItem, setMenu,setCarCategories,setPriceStairs,setHowItWork,setCities,
    setAbout, setMediaUrl , setRecommendations, setLeasingCompanies, setCarsBanners, setRoutTable, setPrepay} from '../../redux/actions';


class GeneralDeclarationRequest extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'General Declaration Request';
        this.Config   = new AppConfig();
    }

    execute(dispatch) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.generalDeclaration);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(setTranslations(this.response.data.translationsArr));
        this.dispatch(setWebMode(this.response.data.web_mode));
        this.dispatch(setAbout(this.response.data['who-we-are']));
        this.dispatch(setMediaUrl(this.response.data.media_server));
        this.dispatch(setRecommendations(this.response.data['recommenders-slider']));
        this.dispatch(setPeepsScors(this.response.data['peeps-score']));
        this.dispatch(setDate(this.response.data['its-a-date']));
        this.dispatch(setEasySearch(this.response.data['easy-search']));
        this.dispatch(setFlowInformation(this.response.data['flow-information']));
        this.dispatch(setLeasingCompanies(this.response.data['leasing-companies']));
        this.dispatch(setEasyBuy(this.response.data['easy-buy']));
        this.dispatch(setFooterItem(this.response.data['footer']));
        this.dispatch(setMenu(this.response.data['main_menu']));
        this.dispatch(setCarCategories(this.response.data['car-categories']));
        this.dispatch(setPriceStairs(this.response.data['price-stairs']));
        this.dispatch(setSortTypes(this.response.data['sort-types']));
        this.dispatch(setCarsBanners(this.response.data['cars-banners']));
        this.dispatch(setAboutPage(this.response.data.about));
        this.dispatch(setHowItWork(this.response.data['how-does-it-work']));
        this.dispatch(setRoutTable(this.response.data['contentUrls']));
        this.dispatch(setFaq(this.response.data.faqs));
        this.dispatch(setCities(this.response.data.cities));
        this.dispatch(setPrepay(this.response.data['car-prepay']));


        window.media_url = this.response.data['media_server'] === '' ? 'https://media.peeps.co.il' : this.response.data['media_server'];
    }
}


export default GeneralDeclarationRequest;